import { render, staticRenderFns } from "./FormCreateNote.vue?vue&type=template&id=13daefd7&"
import script from "./FormCreateNote.vue?vue&type=script&lang=js&"
export * from "./FormCreateNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports